<template>
  <fieldset class="step step--2">
    <Section :title="stepTitle">
      <CertificationFormGroup name="eventName">
        <template slot-scope="{ validator }">
          <InputControl
            id="eventName"
            v-model="form.eventName"
            number="1"
            label="Nazwa wydarzenia"
            :disabled="formDisabled"
            @input="eventNameInput($event, validator)"
          />
        </template>
      </CertificationFormGroup>
      <transition name="slide-fade">
        <div v-show="form.eventName && !v.form.eventName.$anyError">
          <FormGroup :name="`date.$each.0.generalError`">
            <template slot-scope="{ validator }">
              <InputHiddenControl id="'date-general-' + idx" />
            </template>
          </FormGroup>

          <CertificationFormGroup name="date.$each.0.dateStart">
            <template slot-scope="{ validator }">
              <DateControl
                id="dateStart"
                v-model="form.date[0].dateStart"
                number="2"
                label="Data rozpoczęcia wydarzenia"
                :inline="true"
                type="date"
                :disabled="formDisabled"
                @input="touch(validator)"
              />
              <BAlert
                v-if="isHolidays && isAdmin"
                variant="warning"
                class="form__alert-holidays"
                show
                style="margin-left: 30px;"
              >
                <strong>
                  Uwaga:
                  {{ isHolidays }}
                </strong>
              </BAlert>
            </template>
          </CertificationFormGroup>
          <!-- <transition name="slide-fade"> -->
          <!-- <div v-show="dateIs45"> -->
          <CertificationFormGroup name="date.$each.0.dateEnd">
            <template slot-scope="{ validator }">
              <DateControl
                id="dateEnd"
                v-model="form.date[0].dateEnd"
                number="3"
                label="Data zakończenia wydarzenia"
                :inline="true"
                type="date"
                :allow-all-caps="true"
                :disabled="formDisabled"
                @input="touch(validator)"
              />
            </template>
          </CertificationFormGroup>

          <div class="row">
            <div class="offset-sm-7 col-sm-5">
              <BAlert
                v-if="!dateIs45"
                variant="warning"
                class="form__alert-holidays"
                show
              >
                <strong>
                  Uwaga:
                </strong>
                Informujemy, że wydarzenie może nie zostać zweryfikowane w
                związku ze zbyt późnym zgłoszeniem. Prosimy o upewnienie się,
                czy wydarzenie spełnia kryteria opisane
                <a :href="`${publicUrl}sowe/kryteria-oceny/`" target="_blank"
                  >TUTAJ</a
                >
              </BAlert>
            </div>
          </div>

          <CertificationFormGroup name="q_2_4">
            <template slot-scope="{ validator }">
              <TrueFalseControl
                id="q_2_4"
                v-model="form.q_2_4"
                number="4"
                label="Istnieje strona internetowa wydarzenia"
                :disabled="formDisabled"
              />
            </template>
          </CertificationFormGroup>
          <transition name="slide-fade">
            <CertificationFormGroup v-show="form.q_2_4" name="url">
              <template slot-scope="{ validator }">
                <InputControl
                  id="url"
                  v-model="form.url"
                  number="4a"
                  label="Proszę podać adres www wydarzenia"
                  :disabled="formDisabled"
                  @input="touch(validator)"
                />
              </template>
            </CertificationFormGroup>
          </transition>
          <CertificationFormGroup name="eventType">
            <template slot-scope="{ validator }">
              <RadioControl
                id="event-type"
                v-model="form.eventType"
                :options="eventType"
                number="5"
                :get-object="false"
                label="Rodzaj wydarzenia"
                :disabled="formDisabled"
              />
            </template>
          </CertificationFormGroup>
          <CertificationFormGroup name="editions">
            <RadioControl
              id="editions"
              v-model="form.editions"
              :options="editionsType"
              number="6"
              :get-object="false"
              label="Liczba dotychczasowych edycji wydarzenia"
              :disabled="formDisabled"
            />
          </CertificationFormGroup>
          <CertificationFormGroup name="audienceAmount">
            <RadioControl
              id="audienceAmount"
              v-model="form.audienceAmount"
              :options="audienceAmountType"
              number="7"
              :get-object="false"
              label="Spodziewana liczba uczestników"
              :disabled="formDisabled"
            />
          </CertificationFormGroup>
          <CertificationFormGroup name="q_2_8">
            <TrueFalseControl
              id="q_2_8"
              v-model="form.q_2_8"
              number="8"
              label="Organizator przewiduje/planuje udział firm w charakterze sponsorów"
              label-description="np. wystawa firm, możliwość promocji/ reklamy firm, wykłady sponsorowane itp."
              :disabled="formDisabled"
            />
          </CertificationFormGroup>
          <transition name="slide-fade">
            <CertificationFormGroup v-show="form.q_2_8" name="q_2_8a">
              <TrueFalseControl
                id="q_2_8a"
                v-model="form.q_2_8a"
                number="8a"
                label="Wydarzenie będzie sponsorowane wyłącznie przez jedną firmę/wystawcę/partnera"
                :disabled="formDisabled"
              />
            </CertificationFormGroup>
          </transition>
          <transition name="slide-fade">
            <CertificationFormGroup
              v-show="form.q_2_8 && form.q_2_8a"
              name="q_2_8b"
            >
              <TrueFalseControl
                id="q_2_8b"
                v-model="form.q_2_8b"
                number="8b"
                label="Organizator udostępni możliwość udziału w wydarzeniu innym firmom"
                label-description="np. przedstawiając ofertę sponsoringu, zapraszając do udziału itp."
                :disabled="formDisabled"
              />
            </CertificationFormGroup>
          </transition>
          <CertificationFormGroup name="eventArea">
            <template slot-scope="{ validator }">
              <RadioControl
                id="event-area"
                v-model="form.eventArea"
                :options="eventAreaType"
                number="9"
                :get-object="false"
                label="Zgłaszane wydarzenie dotyczy zagadnień z obszaru:"
                :disabled="formDisabled"
                @input="touch(validator)"
              />
            </template>
          </CertificationFormGroup>
          <!-- </div> -->
          <!-- </transition> -->
        </div>
      </transition>
    </Section>
  </fieldset>
</template>

<script>
import BaseCertificationFormStep from "@/components/Base/Certification/BaseCertificationFormStep";
import InputControl from "@/components/Controls/InputControl";
import DateControl from "@/components/Controls/DateControl";
import TrueFalseControl from "@/components/Controls/TrueFalseControl";
import RadioControl from "@/components/Controls/RadioControl";
import InputHiddenControl from "@/components/Controls/InputHiddenControl";
import { isHolidays } from "@/helpers/IsHolidays";
import { mapGetters } from "vuex";
import moment from "moment";

import {
  internationalType,
  eventType,
  editionsType,
  audienceAmountType,
  eventAreaType
} from "./data";

import { date45Days } from "@/validation/";

export default {
  name: "CertificationFormStep2",
  components: {
    InputControl,
    TrueFalseControl,
    RadioControl,
    DateControl,
    InputHiddenControl
  },
  extends: BaseCertificationFormStep,
  data() {
    return {
      internationalType,
      eventType,
      editionsType,
      audienceAmountType,
      eventAreaType,
      dateIs45: true,
      publicUrl: process.env.VUE_APP_PUBLIC_URL
    };
  },
  computed: {
    ...mapGetters("Form", ["total"]),
    ...mapGetters("User", ["isAdmin"]),
    isHolidays() {
      return isHolidays(this.form.date[0].dateStart, this.form.date[0].dateEnd);
    }
  },
  watch: {
    "form.eventType": function(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue == "practice") {
          this.showPracticeInfo();
        }
      }
    },
    "form.date.0.dateStart": function(newValue) {
      if (
        !this.form.date[0].dateEnd ||
        moment(this.form.date[0].dateEnd).isBefore(newValue)
      ) {
        let date = this.form.date[0];
        date.dateEnd = date.dateStart;
        this.$set(this.form.date, 0, date);
      }
      if (!date45Days(newValue)) {
        // this.disableAllSteps();
        this.dateIs45 = false;
      } else {
        this.enableAllSteps();
        this.dateIs45 = true;
      }
    }
  },
  methods: {
    eventNameInput(name, validator) {
      if (name.length > 2) {
        this.enableAllSteps();
      } else {
        this.disableAllSteps();
      }
      this.touch(validator);
    },
    enableAllSteps() {
      this.$store.dispatch("Form/enableAllSteps");
    },
    disableAllSteps() {
      this.$store.dispatch("Form/disableAllSteps");
    },
    showPracticeInfo() {
      let h = this.$createElement;
      let msg = [
        "Jako rodzaj wydarzenia wskazano szkolenie z procedur. Proszę upewnić się, że organizowane przez Państwa wydarzenie spełnia dodatkowe kryteria opisane tutaj (",

        h(
          "a",
          {
            attrs: {
              href: `${process.env.VUE_APP_PUBLIC_URL}sowe/szkolenia-z-procedur/`,
              target: "_blank"
            }
          },
          "link do kryteriów"
        ),
        ")"
      ];

      this.$bvModal.msgBoxOk(msg);
    }
  }
};
</script>

<style scoped>
.form__alert-holidays {
  font-size: 0.8em;
  padding: 0.37rem 0.625rem;
}
</style>
